<div role="banner" [ngClass]="bannerClass()">
  <div class="banner-background">
    <div class="banner-container">
      <h1
        class="banner-title"
        [innerHTML]="'wl.westpac.home_page.banner.title' | translate"></h1>
    </div>
  </div>
  <rd-banner-image
    [bannerSrc]="{
      desktop: 'homepage-kv-desktop',
      mobile: 'homepage-kv-mobile'
    }"></rd-banner-image>
</div>
<div class="upper-detail">
  <div class="upper-details-container">
    <div class="detail-container-item">
      <h2 class="title">
        {{ 'wl.westpac.home_page.tile.discover_benefits' | translate }}
      </h2>
      <div class="tile-container">
        <a
          title="special offer"
          class="flex h-[112px] w-full bg-cover p-4 no-underline focus-link md:h-[256px]"
          [ngStyle]="specialOffersBgImage"
          [routerLink]="['/offers']">
          <div class="tile-background-description-container">
            <div class="tile-background-description-title-container">
              <h3 class="tile-background-description-title">
                {{ 'wl.westpac.home_page.tile.special_offers' | translate }}
              </h3>
              <p
                class="tile-background-description-subtitle"
                *ngIf="showSubtitle">
                {{
                  'wl.westpac.home_page.tile.special_offers_details' | translate
                }}
              </p>
            </div>
            <rd-shared-icon
              class="chevron"
              [iconSymbol]="'icon-chevron-right'"
              [iconTheme]="'white'"></rd-shared-icon>
          </div>
        </a>
      </div>
    </div>
    <div class="detail-container-item">
      <h2 class="title">
        {{ 'wl.westpac.home_page.tile.in_app_discount' | translate }}
      </h2>
      <div class="tile-container">
        <a
          class="tile-background hotel focus-link"
          [ngStyle]="hotelsBgImage"
          [href]="travelEdgeUrl">
          <div class="tile-background-description-container">
            <div class="tile-background-description-title-container">
              <h3 class="tile-background-description-title">
                {{ 'wl.westpac.home_page.tile.hotels' | translate }}
              </h3>
              <p
                class="tile-background-description-subtitle"
                *ngIf="showSubtitle">
                {{ 'wl.westpac.home_page.tile.hotels_details' | translate }}
              </p>
            </div>
            <rd-shared-icon
              class="chevron"
              [iconSymbol]="'icon-chevron-right'"
              [iconTheme]="'white'"></rd-shared-icon>
          </div>
        </a>
        <a
          class="tile-background focus-link"
          [ngStyle]="giftCardsBgImage"
          [routerLink]="['/gift_card']">
          <div class="tile-background-description-container">
            <div class="tile-background-description-title-container">
              <h3 class="tile-background-description-title">
                {{ 'wl.westpac.home_page.tile.gift_cards' | translate }}
              </h3>
              <p
                class="tile-background-description-subtitle"
                *ngIf="showSubtitle">
                {{ 'wl.westpac.home_page.tile.gift_cards_details' | translate }}
              </p>
            </div>
            <rd-shared-icon
              class="chevron"
              [iconSymbol]="'icon-chevron-right'"
              [iconTheme]="'white'"></rd-shared-icon>
          </div>
        </a>
      </div>
    </div>
  </div>
  <div class="recommended-offers-container">
    <div class="recommended-offers">
      <div class="recommended-offers-title-container">
        <h2 class="title recommended-offers-title">
          {{ 'wl.westpac.home_page.tile.recommended_offers' | translate }}
        </h2>
        <a
          [routerLink]="getOfferListingPageUrl()"
          class="recommended-offers-see-all-link focus-link">
          <span class="recommended-offers-see-all">
            {{
              'wl.westpac.home_page.tile.recommended_offers_see_all' | translate
            }}
          </span>
          <rd-shared-icon
            class="chevron recommended-offers-see-all-icon"
            [iconSymbol]="'icon-chevron-right'"
            [iconTheme]="'error'"></rd-shared-icon>
        </a>
      </div>

      <ng-container [ngSwitch]="recommendedOffersStatus$ | async">
        <ng-container *ngSwitchCase="'loading'">
          <div class="recommended-offers-list-container">
            <ng-container *ngFor="let offer of [1, 2, 3]">
              <div class="offer-list-item">
                <rd-offer-listing-item [loading]="true">
                </rd-offer-listing-item>
              </div>
            </ng-container>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'loaded'">
          <div class="recommended-offers-list-container">
            <ng-container *ngFor="let offer of recommendedOffers$ | async">
              <div class="offer-list-item">
                <rd-offer-listing-item
                  [url]="getOfferDetailsPageUrl(offer.id)"
                  [brand]="offer.brand"
                  [title]="offer.title"
                  [categoryIcon]="''"
                  [logo]="offer.logoUrl"
                  [cover]="offer.coverImageUrl"
                  [loading]="false">
                </rd-offer-listing-item>
              </div>
            </ng-container>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'error'">
          <rd-shared-error-sign></rd-shared-error-sign>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
